import classNames from 'classnames'
import { FC } from 'react'
import { onKbClick } from 'web/utils/utils'

export const AddEventToggleTab: FC<{ open: boolean; toggle: () => void }> = ({ open, toggle }) => {
    return (
        <div
            onClick={toggle}
            onKeyPress={onKbClick(toggle)}
            tabIndex={0}
            className={classNames(
                "cursor-pointer",
                "d-flex align-items-center",
                "justify-content-center px-2",
                "bg-light small border text-muted",
                "border-bottom-0"
            )}
            style={{
                width: "125px"
            }}
        >
            {open
                ? "Hide event input"
                : "Show event input"}
        </div>
    )
}
